import React from 'react';
import { useStyles } from './styles';
import { Box, Button, Typography } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import CancelIcon from '@material-ui/icons/Cancel';
import IconButton from '@material-ui/core/IconButton';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';

export const FileSizeAlert = (props) => {

  const { open, handleAlertClose, file} = props;
  const classes = useStyles();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Dialog
      fullScreen={fullScreen}
      width="600px"
      PaperProps={{ classes: { root: classes.dialogStyle } }} onClose={handleAlertClose} open={open}
    >
      <Box className={classes.root}>
        <IconButton className={classes.iconStyle} onClick={handleAlertClose}>
          <CancelIcon />
        </IconButton>
        <Box className={classes.header}>
          <Typography className={classes.subTitle}>The file "{file}" is too large.</Typography>
          <Typography className={classes.paragraph}>Allowed maximum size is 5 MB.</Typography>
        </Box>
      </Box>
    </Dialog>
  )
}
